import { startCase } from "lodash";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import { SVG_MUI } from "@ryde/assets";
import { useBookingsNavigation, useGlobalEffectActions } from "@ryde/redux";
import {
  displayedRowsCountSF,
  selectedBookingsCountSelector,
  selectedCellsBookingCalendarAtom,
  useIsMobile,
  visiblePassengersBookingsSelector,
} from "@ryde/shared";

import { EditGridColumnButton, PanelTopRightStatItem } from "../elements";
import { PanelStatStyled } from "./panel-top.stat.styled";

export const PanelTopStatBookings: FC = () => {
  const { isMobile } = useIsMobile();
  const { t } = useTranslation();
  const passengers = useRecoilValue(visiblePassengersBookingsSelector);
  const { isCalendarBookingView } = useBookingsNavigation();
  const { collapseExpandedRowsAppEvent } = useGlobalEffectActions();
  const { size: selectedCellsCount } = useRecoilValue(
    selectedCellsBookingCalendarAtom,
  );
  const bookingsCount = useRecoilValue(displayedRowsCountSF("booking"));
  const selectedBookingsCount = useRecoilValue(selectedBookingsCountSelector);
  return (
    <PanelStatStyled>
      {!isMobile && !isCalendarBookingView && (
        <SVG_MUI.ArrowStatCollapse3SVG onClick={collapseExpandedRowsAppEvent} />
      )}
      {isCalendarBookingView && (
        <>
          <PanelTopRightStatItem
            e2eId="stat-bookings-selected-cells-count"
            selected={selectedCellsCount}
            hideTotal={true}
            label={t("booking.ui.selectedCells")}
          />
          <PanelTopRightStatItem
            e2eId="stat-bookings-passengers-count"
            selected={passengers.length}
            hideTotal={true}
            label={startCase(t("passenger.plural"))}
          />
        </>
      )}

      <PanelTopRightStatItem
        e2eId="stat-bookings-passengers-count"
        selected={selectedBookingsCount}
        total={bookingsCount}
        hideSelected={isCalendarBookingView}
        label={startCase(t("booking.plural"))}
      />
      {Boolean(isMobile) && (
        <div className="stat_panel_end">
          <EditGridColumnButton />
        </div>
      )}
    </PanelStatStyled>
  );
};
